module.exports = __webpack_public_path__ + "static/media/Redland.bd64ef4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Redland.jpg
// module id = 655
// module chunks = 0